// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-container {
  padding: 24px 32px;
  max-width: 1400px;
  margin: 0 auto;
}

.kb-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e8eaed;
}

.kb-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a2e;
}

.kb-search {
  display: flex;
  gap: 8px;
  align-items: center;
}

.kb-search input {
  width: 320px;
  border-radius: 20px;
  padding-left: 16px;
  border: 1px solid #dde1e6;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.kb-search input:focus {
  border-color: #4a90d9;
  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.12);
}

.kb-body {
  display: flex;
  gap: 32px;
}

.kb-sidebar {
  min-width: 240px;
  max-width: 240px;
}

.kb-sidebar h5 {
  margin-bottom: 14px;
  font-weight: 700;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #6c757d;
  padding-left: 12px;
}

.kb-category-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-radius: 8px;
  color: #374151;
  text-decoration: none;
  margin-bottom: 4px;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.15s ease;
  border: 1px solid transparent;
}

.kb-category-link:hover {
  background: #f4f6f9;
  color: #1a1a2e;
  text-decoration: none;
  border-color: #e8eaed;
}

.kb-category-link.active {
  background: #eef4fc;
  color: #1565c0;
  font-weight: 600;
  border-color: #bbdefb;
}

.kb-category-link .badge {
  font-size: 0.7rem;
  font-weight: 600;
  min-width: 22px;
  padding: 3px 7px;
  border-radius: 10px;
}

.kb-content {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e8eaed;
  padding: 24px;
}

.kb-search-results {
  margin-top: 16px;
}

.kb-search-results h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 16px;
}

.kb-search-item {
  padding: 14px 0;
  border-bottom: 1px solid #f0f0f0;
}

.kb-search-item:last-child {
  border-bottom: none;
}

.kb-search-item a {
  color: #1565c0;
  font-weight: 500;
}

.kb-search-item a:hover {
  color: #0d47a1;
}

.kb-search-item .badge {
  margin-left: 10px;
  font-size: 0.7rem;
  font-weight: 500;
}

.kb-search-item .snippet {
  margin: 6px 0 0;
  font-size: 0.84em;
  color: #6c757d;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/app/knowledge-base-module/components/kb-layout/kb-layout.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".kb-container {\n  padding: 24px 32px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.kb-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 28px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #e8eaed;\n}\n\n.kb-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1a1a2e;\n}\n\n.kb-search {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.kb-search input {\n  width: 320px;\n  border-radius: 20px;\n  padding-left: 16px;\n  border: 1px solid #dde1e6;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.kb-search input:focus {\n  border-color: #4a90d9;\n  box-shadow: 0 0 0 3px rgba(74, 144, 217, 0.12);\n}\n\n.kb-body {\n  display: flex;\n  gap: 32px;\n}\n\n.kb-sidebar {\n  min-width: 240px;\n  max-width: 240px;\n}\n\n.kb-sidebar h5 {\n  margin-bottom: 14px;\n  font-weight: 700;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: #6c757d;\n  padding-left: 12px;\n}\n\n.kb-category-link {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  border-radius: 8px;\n  color: #374151;\n  text-decoration: none;\n  margin-bottom: 4px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: all 0.15s ease;\n  border: 1px solid transparent;\n}\n\n.kb-category-link:hover {\n  background: #f4f6f9;\n  color: #1a1a2e;\n  text-decoration: none;\n  border-color: #e8eaed;\n}\n\n.kb-category-link.active {\n  background: #eef4fc;\n  color: #1565c0;\n  font-weight: 600;\n  border-color: #bbdefb;\n}\n\n.kb-category-link .badge {\n  font-size: 0.7rem;\n  font-weight: 600;\n  min-width: 22px;\n  padding: 3px 7px;\n  border-radius: 10px;\n}\n\n.kb-content {\n  flex: 1;\n  min-width: 0;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #e8eaed;\n  padding: 24px;\n}\n\n.kb-search-results {\n  margin-top: 16px;\n}\n\n.kb-search-results h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 16px;\n}\n\n.kb-search-item {\n  padding: 14px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.kb-search-item:last-child {\n  border-bottom: none;\n}\n\n.kb-search-item a {\n  color: #1565c0;\n  font-weight: 500;\n}\n\n.kb-search-item a:hover {\n  color: #0d47a1;\n}\n\n.kb-search-item .badge {\n  margin-left: 10px;\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.kb-search-item .snippet {\n  margin: 6px 0 0;\n  font-size: 0.84em;\n  color: #6c757d;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
